import React, { useEffect, useState } from "react";
import "./dashboard.css";
import { Breadcrumb } from "antd";
import {
  Offer,
  dashboardUser,
  employer,
  homeIcon,
  offer,
  productIcon1,
  serviceIcon1,
} from "../../assets";
import Clock from "react-clock";
import "react-clock/dist/Clock.css";
import moment from "moment/moment";
import { callApi } from "../../api/apiCaller";
import { routes } from "../../api/routes";
import Loader from "../../components/loader/loader";
const Dashboard = () => {
  const [value, setValue] = useState(new Date());
  const [isloading, setIsLoading] = useState(true);
  const [employers, setEmployers] = useState([]);
  const [getServiceapi, setGetServiceApi] = useState(false);
  const [updateApi, setUpdateApi] = useState(false);
  const [users, setUsers] = useState([]);
  const [engOffers, setEngOffers] = useState([]);
  const [arabicOffers, setArabicOffers] = useState([]);

  const stateArr = [
    {
      title: "Total Users",
      count: users?.length,
      icon: dashboardUser,
    },
    {
      title: "Total Employers",
      count: employers?.length,
      icon: employer,
    },
    {
      title: "Total Eng Offers",
      count: engOffers?.length,
      icon: offer,
    },
    {
      title: "Total Arabic Offers",
      count: arabicOffers?.length,
      icon: offer,
    },
  ];

  const getAllUser = () => {
    let getRes = (res) => {
      console.log("res of user list", res);
      setUsers(res?.data?.data);
    };

    callApi("GET", routes.getAllUsers, null, setIsLoading, getRes, (error) => {
      console.log("error", error);
    });
  };

  useEffect(() => {
    getAllUser();
  }, [updateApi]);

  const getAllEmployers = () => {
    let getRes = (res) => {
      console.log("res of getAllEmployers", res);
      setEmployers(res?.data?.data);
    };

    callApi(
      "GET",
      routes.getAllEmployers,
      null,
      setIsLoading,
      getRes,
      (error) => {
        console.log("error", error);
      }
    );
  };

  useEffect(() => {
    getAllEmployers();
  }, [getServiceapi]);

  const getAllEngOffers = () => {
    let getRes = (res) => {
      console.log("res of getAllEngOffers", res);
      setEngOffers(res?.data?.data);
    };

    callApi(
      "GET",
      routes.getAllEngOffers,
      null,
      setIsLoading,
      getRes,
      (error) => {
        console.log("error", error);
      }
    );
  };

  useEffect(() => {
    getAllEngOffers();
  }, [getServiceapi]);

  const getAllArbicOffers = () => {
    let getRes = (res) => {
      console.log("res of getAllArbicOffers", res);
      setArabicOffers(res?.data?.data);
    };

    callApi(
      "GET",
      routes.getAllArabicOffers,
      null,
      setIsLoading,
      getRes,
      (error) => {
        console.log("error", error);
      }
    );
  };

  useEffect(() => {
    getAllArbicOffers();
  }, [getServiceapi]);

  return (
    <div className="modern-dashboard-container">
      <Loader loading={isloading} />

      {/* Page Header */}
      <div className="dashboard-header">
        <div>
          <Breadcrumb
            separator="›"
            className="modern-breadcrumb"
            items={[
              { title: "Home" },
              { title: <span className="breadcrumb-active">Dashboard</span> },
            ]}
          />
          <h1 className="dashboard-title">Welcome to JAK Admin Panel</h1>
          <p className="dashboard-subtitle">Overview of your system statistics</p>
        </div>
      </div>

      {/* Stats Grid */}
      <div className="dashboard-grid">
        {/* Stats Cards */}
        <div className="dashboard-stats-wrapper">
          <div className="dashboard-stat-card" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
            <div className="stat-card-content">
              <div className="stat-icon-circle">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <div className="stat-details">
                <p className="stat-title">Total Users</p>
                <h2 className="stat-number">{users?.length || 0}</h2>
                <span className="stat-badge">All registered users</span>
              </div>
            </div>
          </div>

          <div className="dashboard-stat-card" style={{ background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)' }}>
            <div className="stat-card-content">
              <div className="stat-icon-circle">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 7H4C2.89543 7 2 7.89543 2 9V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19V9C22 7.89543 21.1046 7 20 7Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M16 21V5C16 4.46957 15.7893 3.96086 15.4142 3.58579C15.0391 3.21071 14.5304 3 14 3H10C9.46957 3 8.96086 3.21071 8.58579 3.58579C8.21071 3.96086 8 4.46957 8 5V21" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <div className="stat-details">
                <p className="stat-title">Total Employers</p>
                <h2 className="stat-number">{employers?.length || 0}</h2>
                <span className="stat-badge">Active employers</span>
              </div>
            </div>
          </div>

          <div className="dashboard-stat-card" style={{ background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)' }}>
            <div className="stat-card-content">
              <div className="stat-icon-circle">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 12V8H6C5.46957 8 4.96086 7.78929 4.58579 7.41421C4.21071 7.03914 4 6.53043 4 6C4 4.9 4.9 4 6 4H18V8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M4 6V18C4 19.1 4.9 20 6 20H20V16H6C4.9 16 4 15.1 4 14V6Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <div className="stat-details">
                <p className="stat-title">English Offers</p>
                <h2 className="stat-number">{engOffers?.length || 0}</h2>
                <span className="stat-badge">Total Eng offers</span>
              </div>
            </div>
          </div>

          <div className="dashboard-stat-card" style={{ background: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)' }}>
            <div className="stat-card-content">
              <div className="stat-icon-circle">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 12V8H6C5.46957 8 4.96086 7.78929 4.58579 7.41421C4.21071 7.03914 4 6.53043 4 6C4 4.9 4.9 4 6 4H18V8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M4 6V18C4 19.1 4.9 20 6 20H20V16H6C4.9 16 4 15.1 4 14V6Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <div className="stat-details">
                <p className="stat-title">Arabic Offers</p>
                <h2 className="stat-number">{arabicOffers?.length || 0}</h2>
                <span className="stat-badge">Total Arabic offers</span>
              </div>
            </div>
          </div>
        </div>

        {/* Clock Widget */}
        <div className="dashboard-clock-card">
          <h3 className="clock-title">Current Time</h3>
          <div className="clock-wrapper">
            <Clock size={110} value={value} />
          </div>
          <div className="time-display">
            <p className="current-date">{moment(new Date()).format("dddd, MMMM DD, YYYY")}</p>
            <p className="current-time">{moment(new Date()).format("hh:mm A")}</p>
          </div>
        </div>
      </div>

      {/* Quick Stats Summary */}
      <div className="dashboard-summary-card">
        <h2 className="summary-title">System Overview</h2>
        <div className="summary-grid">
          <div className="summary-item">
            <span className="summary-label">Total Users</span>
            <span className="summary-value">{users?.length || 0}</span>
          </div>
          <div className="summary-divider"></div>
          <div className="summary-item">
            <span className="summary-label">Total Employers</span>
            <span className="summary-value">{employers?.length || 0}</span>
          </div>
          <div className="summary-divider"></div>
          <div className="summary-item">
            <span className="summary-label">Total Offers</span>
            <span className="summary-value">{(engOffers?.length || 0) + (arabicOffers?.length || 0)}</span>
          </div>
          <div className="summary-divider"></div>
          <div className="summary-item">
            <span className="summary-label">System Status</span>
            <span className="summary-status">
              <span className="status-dot"></span>
              Active
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
